import React from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { HiOutlineListBullet } from "react-icons/hi2";

export default function MenuTool({ menus, actions }: any) {
  return (
    <div className="border-b bg-white text-sm flex justify-between items-center px-4">
      <div className="">
        {menus?.map((menu: any, index: number) => (
          <MenuItem menu={menu} key={index} />
        ))}
      </div>
      <div className="">{actions}</div>
    </div>
  );
}

function MenuItem({ menu }: any) {
  let resolved = useResolvedPath(menu?.to);
  let match = useMatch({ path: resolved.pathname, end: false });
  return (
    <Link
      className={`flex justify-center items-center py-2 hover:text-red-600 border-b${
        match ? " border-toyota-dark" : "border-gray-50"
      }`}
      to={menu?.to}
    >
      <HiOutlineListBullet />
      <span className="ml-1">{menu?.name}</span>
    </Link>
  );
}
